export default "__VITE_ASSET__R8vFXVt4__"